import { EVENT_LABEL, GROUPS, eventGroup } from "../lib/colors";
import { fmtDeaths } from "../lib/format";
import { useApp } from "../lib/store";

const PRECISION = ["", "exact place", "within ~25 km", "district level", "province level", "along a road or border", "country only", "at sea / in the air"];

export function EventCard() {
  const e = useApp((s) => s.event);
  const c = useApp((s) => s.conflicts);
  const setEvent = useApp((s) => s.setEvent);
  const select = useApp((s) => s.select);
  if (!e || !c) return null;
  const root = e.conflict >= 0 ? (c.r[e.conflict] >= 0 ? c.r[e.conflict] : e.conflict) : -1;
  const grp = eventGroup(e.kind, root >= 0 ? c.kind[root] : null);
  return (
    <section className="event-card" data-testid="event-card" aria-live="polite">
      <button className="close" onClick={() => setEvent(null)} aria-label="Close">×</button>
      <div className="ec-kind"><span className="dot" style={{ background: GROUPS[grp].hex }} aria-hidden />{EVENT_LABEL[e.kind] ?? "Event"}{e.provisional ? " · provisional" : ""}</div>
      <h2>{e.name}</h2>
      <p className="ec-date">{e.date}{e.place ? ` · ${e.place}` : ""}</p>
      {e.deaths ? <p><strong>{fmtDeaths(e.deaths)}</strong> deaths{e.src === "ged" ? " (UCDP best estimate)" : e.url ? "" : " (as cited on Wikidata)"}</p> : null}
      {e.src === "ged" && e.precise ? <p className="muted">Location: {PRECISION[e.precise] ?? "approximate"}</p> : null}
      {root >= 0 && (
        <p>Part of <button className="link" onClick={() => select(root)}>{c.name[root]}</button>
          {e.conflict !== root ? <> · <button className="link" onClick={() => select(e.conflict)}>{c.name[e.conflict]}</button></> : null}
        </p>
      )}
      {e.id && !e.id.startsWith("Q") && e.url && (
        <p className="ec-links"><a href={e.url} target="_blank" rel="noopener">Source</a></p>
      )}
      {e.id?.startsWith("Q") && (
        <p className="ec-links">
          <a href={`https://www.wikidata.org/wiki/Special:GoToLinkedPage/enwiki/${e.id}`} target="_blank" rel="noopener">Wikipedia</a>
          {" · "}
          <a href={`https://www.wikidata.org/wiki/${e.id}`} target="_blank" rel="noopener">Wikidata</a>
        </p>
      )}
      {e.src === "ged" && <p className="ec-links muted">Event from the UCDP Georeferenced Event Dataset</p>}
    </section>
  );
}
